import { useContext, useState } from "react";
import { AppContext } from "../../scripts/context";
import ActionStyle from "./style";

export default function MetaMaskActions() {
  const {
    state: {
      contracts: {
        lpToken: { contract: lpTokenContract },
      },
    },
  } = useContext(AppContext);
  const [addingAsset, setAddingAsset] = useState(false);

  const addLPToMetamask = async () => {
    setAddingAsset(true);
    const data = await Promise.all([
      lpTokenContract.decimals(),
      lpTokenContract.symbol(),
    ]);
  
    try {
      const result = await window.ethereum.request({
        method: "wallet_watchAsset",
        params: {
          type: "ERC20", // Initially only supports ERC20, but eventually more!
          options: {
            address: process.env.REACT_APP_LP_CONTRACT_ADDRESS, // The address that the token is at.
            symbol: "BULT-TF LP", // A ticker symbol or shorthand, up to 5 chars.
            decimals: data[0], // The number of decimals in the token
          },
        },
      });
      result.wait().then(() => {
        setAddingAsset(false);
      })

    } catch (error) {
      setAddingAsset(false);
      console.log(error);
    }
  };

  return (
    <ActionStyle>
      <button
        onClick={() => {
          window.open(process.env.REACT_APP_BULT_TFULE_LP_LINK, "_blank");
        }}
      >
        <span>Get BULT-TFUEL LP</span>
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.4198 9.40012C17.4198 14.0319 13.6157 17.7954 8.91223 17.7954C4.2088 17.7954 0.404707 14.0319 0.404707 9.40012C0.404707 4.76835 4.2088 1.00484 8.91223 1.00484C13.6157 1.00484 17.4198 4.76835 17.4198 9.40012Z"
            stroke="#6D7D97"
            strokeWidth="0.809414"
          />
          <path
            d="M12.7716 5.58943C11.9759 4.80376 10.6811 4.8036 9.88532 5.589L9.88548 5.58916L8.6264 6.83259L9.20759 7.40634L10.4669 6.16264L10.4668 6.16253C10.9423 5.69385 11.7152 5.69412 12.1904 6.16329C12.6656 6.63247 12.6656 7.39606 12.1904 7.8654L10.3008 9.73106C10.0706 9.9584 9.76455 10.0836 9.43898 10.0836C9.1134 10.0836 8.80727 9.9584 8.57708 9.73106L7.9959 10.3049C8.38137 10.6855 8.8939 10.8951 9.43903 10.8951C9.98416 10.8951 10.4967 10.6855 10.882 10.3049L12.7716 8.43921C13.5672 7.65337 13.5672 6.37494 12.7716 5.58943Z"
            fill="#6D7D97"
          />
          <path
            d="M7.35784 12.6372C6.88251 13.1063 6.10922 13.1062 5.634 12.6369C5.15878 12.1676 5.15878 11.4039 5.63394 10.9346L7.52331 9.06906C7.99864 8.59978 8.77198 8.59978 9.2472 9.06906L9.82844 8.49526C9.03263 7.70953 7.73788 7.70948 6.94218 8.49526L5.0527 10.3608C4.25716 11.1465 4.25716 12.425 5.05276 13.2108C5.45072 13.6037 5.97333 13.8001 6.49605 13.8001C7.01856 13.8001 7.54117 13.6037 7.93891 13.2111L7.93902 13.211L9.19838 11.9672L8.61714 11.3934L7.35784 12.6372Z"
            fill="#6D7D97"
          />
          <path
            d="M12.7716 5.58943C11.9759 4.80376 10.6811 4.8036 9.88532 5.589L9.88548 5.58916L8.6264 6.83259L9.20759 7.40634L10.4669 6.16264L10.4668 6.16253C10.9423 5.69385 11.7152 5.69412 12.1904 6.16329C12.6656 6.63247 12.6656 7.39606 12.1904 7.8654L10.3008 9.73106C10.0706 9.9584 9.76455 10.0836 9.43898 10.0836C9.1134 10.0836 8.80727 9.9584 8.57708 9.73106L7.9959 10.3049C8.38137 10.6855 8.8939 10.8951 9.43903 10.8951C9.98416 10.8951 10.4967 10.6855 10.882 10.3049L12.7716 8.43921C13.5672 7.65337 13.5672 6.37494 12.7716 5.58943Z"
            stroke="#6D7D97"
            strokeWidth="0.323766"
          />
          <path
            d="M7.35784 12.6372C6.88251 13.1063 6.10922 13.1062 5.634 12.6369C5.15878 12.1676 5.15878 11.4039 5.63394 10.9346L7.52331 9.06906C7.99864 8.59978 8.77198 8.59978 9.2472 9.06906L9.82844 8.49526C9.03263 7.70953 7.73788 7.70948 6.94218 8.49526L5.0527 10.3608C4.25716 11.1465 4.25716 12.425 5.05276 13.2108C5.45072 13.6037 5.97333 13.8001 6.49605 13.8001C7.01856 13.8001 7.54117 13.6037 7.93891 13.2111L7.93902 13.211L9.19838 11.9672L8.61714 11.3934L7.35784 12.6372Z"
            stroke="#6D7D97"
            strokeWidth="0.323766"
          />
        </svg>
      </button>
      <button disabled={addingAsset} onClick={addLPToMetamask}>
        <span>Add LP to Metamask</span>
        <img
          className="add-lp-metamask-img"
          src="/img/metamask.webp"
          alt="add-lp"
          style={{ width: "18px", height: "18px" }}
        />
      </button>
    </ActionStyle>
  );
}
